import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import './fonts.css';
import './index.css';
// Theme layer: must stay last so its single-class selectors win over
// /coreui.min.css and index.css without needing !important.
import './theme.css';
import App from './App';
// The service worker is registered from src/RefreshButton.tsx via
// useServiceWorker(), because registration and the "New Version Available" toast
// have to share one registration object.
var container = document.getElementById('root');
var root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
